import styled from "styled-components";

export const MainContainer = styled.div`
  background-color: #c8a770;
  width: 100%;
  height: auto;
  padding: 40px;
  overflow: hidden;
`;

export const InnerMainContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 15px;
  gap: 20px;
  @media (max-width: 575px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ImageContainer = styled.img`
  width: auto;
  height: 550px;
`;

export const RightContainer = styled.div``;

export const Heading = styled.h1`
  font-size: 52px;
  font-family: Poppins-SemiBold;
  color: #373737;
  @media (max-width: 575px) {
    text-align: center;
    font-size: 24px;
  }
`;
export const Description = styled.p`
  font-size: 20px;
  font-family: Poppins-Light;
  color: #ffffff;
  /* line-height: 45px; */
  @media (max-width: 575px) {
    text-align: center;
    font-size: 18px;
    line-height: 32px;
  }
`;

export const Button = styled.button`
  width: 170px;
  height: 60px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 4px solid #ffffff;
  border-radius: 8px;
  opacity: 1;
  cursor: pointer;
`;

export const ButtonContainer = styled.div`
  @media (max-width: 575px) {
    text-align: center;
  }
`;
